/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prompt_TitleInputs */



/**
* | output |
* | --- |
* | "Get notified when your table is ready" |
*
* @param {Notifications_Prompt_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_prompt_title = /** @type {((inputs?: Notifications_Prompt_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prompt_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soyez notifié(e) quand votre table est prête")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reciba avisos cuando su mesa esté lista")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Receba avisos quando sua mesa estiver pronta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricevi un avviso quando il tuo tavolo è pronto")
	return /** @type {LocalizedString} */ ("Get notified when your table is ready")
});